module.exports = __webpack_public_path__ + "img/pdf_icon.8155a4b3.png";